import { render } from "./vproductmanage.vue?vue&type=template&id=99c8e72a&scoped=true"
import script from "./vproductmanage.vue?vue&type=script&lang=js"
export * from "./vproductmanage.vue?vue&type=script&lang=js"

import "./vproductmanage.vue?vue&type=style&index=0&id=99c8e72a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c8e72a"]])

export default __exports__